import React from 'react';
import { motion } from 'framer-motion';

const partners = ['Vodafone', 'O2', 'Ortel Mobile', 'freenet', 'Vodafone', 'O2', 'Ortel Mobile', 'freenet'];

const ProviderLogos: React.FC = () => {
  return (
    <section className="py-12 bg-white border-t border-gray-200 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="text-xl font-medium text-gray-600">Unsere Partner</h3>
        </motion.div>
      </div>

      {/* Infinite marquee */}
      <div className="relative flex overflow-hidden">
        <motion.div
          className="flex gap-16 whitespace-nowrap"
          animate={{ x: ['0%', '-50%'] }}
          transition={{ duration: 18, ease: 'linear', repeat: Infinity }}
        >
          {partners.map((name, i) => (
            <span
              key={i}
              className="text-lg font-bold text-gray-400 tracking-wide hover:text-blue-600 transition-colors duration-300 cursor-default select-none"
            >
              {name}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProviderLogos;
